import {
    AxisGroup,
    AxisSubgroup,
    AxisAbility,
    ICReportData,
    OverviewAbility,
    OverviewGroup,
    OverviewSubAbility,
    OverviewSubgroup,
    RagGroup,
    RagSubgroup,
    RagAbility,
    ICReportPerson,
} from "./icDashboard.types";

export const convertICReportData = (data: ICReportData) => {
    return {
        overview: convertOverview(data),
        leadershipTeam: convertLeadershipTeam(data),
    };
};

// converter for Overview
export const convertOverview = (data: ICReportData): OverviewGroup => {
    const axis = data.ic_report.axis.overall.scores.leadership_ability;
    const rag = data.ic_report.data_series.overall.scores.leadership_ability;

    return {
        group_id: 0,
        ability_group_label: axis._label,
        ability_group_description: axis._caption ?? "",
        ability_group_score: rag?.RAG?.range.label ?? "",
        ability_group_colour: rag?.RAG?.colour ?? null,
        ability_subgroups: convertSubgroups(axis, rag),
    };
};

const convertSubgroups = (axisGroup: AxisGroup, ragGroup: RagGroup): OverviewSubgroup[] => {
    const subgroupKeys = Object.keys(axisGroup).filter((key) => key !== "_label" && key !== "_caption");

    return subgroupKeys.map((subgroupKey, index) => {
        const axisSubgroup = axisGroup[subgroupKey] as AxisSubgroup;
        const ragSubgroup = ragGroup[subgroupKey] as RagSubgroup;

        return {
            subgroup_id: index,
            subgroup_label: axisSubgroup._label,
            subgroup_definition: axisSubgroup._caption ?? "",
            subgroup_score: ragSubgroup?.RAG?.range.label ?? null,
            colour: ragSubgroup?.RAG?.colour ?? null,
            abilities: convertAbilities(axisSubgroup, ragSubgroup),
        };
    });
};

const convertAbilities = (axisSubgroup: AxisSubgroup, ragSubgroup: RagSubgroup): OverviewAbility[] => {
    const abilityKeys = Object.keys(axisSubgroup).filter((key) => key !== "_label" && key !== "_caption");

    return abilityKeys.map((abilityKey) => {
        const axisAbility = axisSubgroup[abilityKey] as AxisAbility;
        const ragAbility = ragSubgroup?.[abilityKey] as RagAbility;
        return {
            label: axisAbility._label,
            score: ragAbility?.RAG?.range.label ?? null,
            colour: ragAbility?.RAG?.colour ?? null,
            ability_definition: axisAbility._caption ?? "",
            sub_abilities: convertSubAbilities(axisAbility, ragAbility),
        };
    });
};

const convertSubAbilities = (axisAbility: AxisAbility, ragAbility: RagAbility): OverviewSubAbility[] => {
    const abilityKeys = Object.keys(axisAbility).filter((key) => key !== "_label" && key !== "_caption");

    return abilityKeys.map((key) => ({
        label: axisAbility[key]._label,
        score: ragAbility?.[key]?.RAG?.range.label ?? null,
        colour: ragAbility?.[key]?.RAG?.colour ?? null,
    }));
};

// converter for LeadershipTeam & Board Structure
const convertLeadershipTeam = (data: ICReportData): ICReportPerson[] => {
    return data.ic_report.data_series.persons.map((person) => ({
        member_id: person.id,
        member_name: person.name,
        job_title: person.job_title ?? null,
        ability_scores: person.scores,
    }));
};
